import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <>
    <path
      d="M22 12C22 17.523 17.523 22 12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12Z"
      fill="currentColor"
    />
  </>
);

const Icon = createSvgIcon(svg, 'DotFill');

export default Icon;
